module.exports = __webpack_public_path__ + "assets/img/1.f0c5ff3a.png";